import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      <section className="page-hero">
        <div className="container">
          <h1>About Cruise Spotter Connect</h1>
          <p className="subtitle">Connecting cruise-interested consumers with expert travel advisors</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="content-grid">
            <div>
              <h2>Our Story</h2>
              <p>
                Cruise Spotter Connect was born from a simple observation: there's a massive disconnect
                in the cruise industry. On one side, millions of people dream about cruising and actively
                seek information online. On the other side, talented travel advisors struggle to find
                quality leads without breaking the bank on expensive advertising.
              </p>
              <p>
                We built a platform that solves both problems. Our 14M+ social media followers and 10K+
                email subscribers are cruise enthusiasts who actively engage with our content. When they're
                ready to book, they call us. We route those calls in real-time to independent travel
                advisors in our network.
              </p>
              <p>
                The result? Consumers get expert guidance from licensed professionals. Travel advisors get
                high-quality leads without monthly fees or long-term contracts. Everyone wins.
              </p>
            </div>
            <div>
              <h2>Our Mission</h2>
              <p>
                To empower independent travel advisors with the tools and leads they need to build
                successful, sustainable businesses in the cruise industry.
              </p>
              <h2>Our Values</h2>
              <ul className="values-list">
                <li><strong>Transparency:</strong> Clear pricing, detailed reporting, no hidden fees</li>
                <li><strong>Quality:</strong> We prioritize lead quality over quantity</li>
                <li><strong>Fairness:</strong> Agents only pay for legitimate, qualified calls</li>
                <li><strong>Support:</strong> We're here to help agents succeed</li>
                <li><strong>Innovation:</strong> Constantly improving our platform and processes</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section gray">
        <div className="container">
          <h2>What Makes Us Different</h2>
          <div className="difference-grid">
            <div className="difference-card">
              <h3>Real-Time Connection</h3>
              <p>
                We don't sell stale leads that have been contacted by 10 other agents. Our calls
                connect in real-time, giving you first access to motivated customers.
              </p>
            </div>
            <div className="difference-card">
              <h3>Pay Per Performance</h3>
              <p>
                No monthly fees, no contracts, no commitments. You only pay when you receive a
                qualified call. If we don't deliver, you don't pay.
              </p>
            </div>
            <div className="difference-card">
              <h3>Lead Ownership</h3>
              <p>
                Once you take a call, that customer is yours. All follow-up calls from that number
                are routed to you for FREE. Build relationships, not just transactions.
              </p>
            </div>
            <div className="difference-card">
              <h3>Complete Control</h3>
              <p>
                Toggle your availability on/off anytime via our app. Control your spend, manage your
                schedule, run your business your way.
              </p>
            </div>
            <div className="difference-card">
              <h3>Quality Standards</h3>
              <p>
                We pre-qualify our audience through years of content and engagement. These aren't
                random clicks—they're cruise enthusiasts who trust our recommendations.
              </p>
            </div>
            <div className="difference-card">
              <h3>Full Transparency</h3>
              <p>
                Call recordings, real-time dashboard, detailed billing breakdowns. You always know
                exactly what you're paying for and why.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2>How We Generate Leads</h2>
          <p>Our lead generation comes from years of building trust with cruise enthusiasts:</p>
          <div className="lead-sources">
            <div className="source">
              <h3>14M+ Social Media Followers</h3>
              <p>
                We've built engaged communities across multiple platforms by sharing valuable cruise
                content, tips, deals, and inspiration. When followers are ready to book, they trust us
                to connect them with the right advisor.
              </p>
            </div>
            <div className="source">
              <h3>10K+ Email Subscribers</h3>
              <p>
                Our email list consists of highly engaged cruise enthusiasts who have opted in to
                receive cruise information, deals, and booking assistance. These leads convert at
                significantly higher rates.
              </p>
            </div>
            <div className="source">
              <h3>Consistent Content Strategy</h3>
              <p>
                We publish helpful, engaging content daily. This builds trust and positions us as a
                valuable resource, ensuring when people are ready to book, we're their first call.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section gray">
        <div className="container contact-section">
          <h2>Get In Touch</h2>
          <p>Questions about our platform? Want to learn more before applying?</p>
          <div className="contact-grid">
            <div className="contact-item">
              <h3>Email</h3>
              <p><a href="mailto:hello@cruisespotterconnect.com">hello@cruisespotterconnect.com</a></p>
              <p><a href="mailto:agents@cruisespotterconnect.com">agents@cruisespotterconnect.com</a></p>
              <p className="small">Monday-Friday, 9 AM - 6 PM EST</p>
            </div>
          </div>
          <Link to="/contact" className="btn btn-primary">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default About;
